<script>
    export let message;
</script>

<main>
    {@html message}
</main>
